import { render } from "./InitPayment.vue?vue&type=template&id=6e2e9d0e&scoped=true"
import script from "./InitPayment.vue?vue&type=script&lang=js"
export * from "./InitPayment.vue?vue&type=script&lang=js"

import "./InitPayment.vue?vue&type=style&index=0&id=6e2e9d0e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e2e9d0e"]])

export default __exports__